/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cloud_Storage_Announcement_DescriptionInputs */

const en_cloud_storage_announcement_description = /** @type {(inputs: Cloud_Storage_Announcement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import your documents from the cloud, then listen right away.`)
};

const es_cloud_storage_announcement_description = /** @type {(inputs: Cloud_Storage_Announcement_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa tus documentos desde la nube y empieza a escucharlos.`)
};

/**
* | output |
* | --- |
* | "Import your documents from the cloud, then listen right away." |
*
* @param {Cloud_Storage_Announcement_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cloud_storage_announcement_description = /** @type {((inputs?: Cloud_Storage_Announcement_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cloud_Storage_Announcement_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cloud_storage_announcement_description(inputs)
	return en_cloud_storage_announcement_description(inputs)
});